import { DropdownFilter } from '@/models/filters/Filters';

export const DEFAULT_FILTER_VALUE = 'null';
export const DEFAULT_FILTER_TEXT = ' - ';

export function getDefaultFilterObject(dropdownFilter: DropdownFilter) {
  const defaultFilter: any = {};
  defaultFilter[dropdownFilter.valuePropName] = DEFAULT_FILTER_VALUE;
  defaultFilter[dropdownFilter.textPropName] = DEFAULT_FILTER_TEXT;
  return defaultFilter;
}
